"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVariant = void 0;
const updateVariant = async (supabase, variant) => {
    delete variant.order_lines;
    delete variant.created_by_user;
    delete variant.payment_methods;
    const { data, error } = await supabase
        .from("order_variants")
        .upsert(variant)
        .single();
    if (error) {
        console.log("error", error);
        throw new Error(error.message);
    }
    return data;
};
exports.updateVariant = updateVariant;
